import type { AxiosResponse } from "axios";

import { getData } from "@/apis/apiInstance";

import type { GetComplianceCalendarPayloadType } from "@/commonTypes/complianceCalendarTypes";

export async function getComplianceCalendarApi(
  data: GetComplianceCalendarPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, search_term, month, year } = data;

  let finalParams = {
    client_code,
    ...(search_term && search_term?.length > 0 && { search_term: search_term }),
    month,
    year,
  };

  return await getData(`finac-crm/compliance/calendar`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
